// extracted by mini-css-extract-plugin
module.exports = {"artworksErrorPage":"ArtworksErrorPage_artworksErrorPage__w5oSp","artworksErrorPageExtended":"ArtworksErrorPage_artworksErrorPageExtended__T_CKc"};